export function sortRegionsForView(zoneA: string, zoneB: string): number {
  if (zoneA === 'TOTAL') {
    return -1;
  } else if (zoneB === 'TOTAL') {
    return 1;
  } else {
    return zoneA.localeCompare(zoneB);
  }
}
